import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Instagram, Twitter } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { imgUrl } from '../lib/utils';
import theme from '../theme.config';
const SITE_LOGO = theme.assets.logo;

export const Footer = () => {
  const { store, isReseller } = useStore();
  const storeName = isReseller ? store?.store_name || 'Store' : theme.brand.name;
  const logoSrc = isReseller && store?.logo_url ? imgUrl(store.logo_url) : SITE_LOGO;
  return (
    <footer className="border-t border-zinc-900 mt-auto bg-[#09090b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={logoSrc} alt={storeName} className="h-9 w-auto object-contain" />
            </Link>
            <p className="text-zinc-400 text-sm max-w-md leading-relaxed">
              {theme.copy.footer.tagline}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-8 h-8 rounded-lg border border-zinc-850 flex items-center justify-center text-zinc-400 hover:text-white hover:border-zinc-700 transition-all">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-zinc-850 flex items-center justify-center text-zinc-400 hover:text-white hover:border-zinc-700 transition-all">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-lg border border-zinc-850 flex items-center justify-center text-zinc-400 hover:text-white hover:border-zinc-700 transition-all">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-wider mb-4">Layanan</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-zinc-400 hover:text-white text-sm transition-colors">Top Up Game</Link></li>
              <li><Link to="/" className="text-zinc-400 hover:text-white text-sm transition-colors">Voucher Digital</Link></li>
              <li><Link to="/track" className="text-zinc-400 hover:text-white text-sm transition-colors">Cek Transaksi</Link></li>
              <li><Link to="/reseller" className="text-zinc-400 hover:text-white text-sm transition-colors">Program Reseller</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-wider mb-4">Informasi</h4>
            <ul className="space-y-2">
              <li><Link to="/page/tentang-kami" className="text-zinc-400 hover:text-white text-sm transition-colors">Tentang Kami</Link></li>
              <li><Link to="/page/kebijakan-privasi" className="text-zinc-400 hover:text-white text-sm transition-colors">Kebijakan Privasi</Link></li>
              <li><Link to="/page/syarat-ketentuan" className="text-zinc-400 hover:text-white text-sm transition-colors">Syarat & Ketentuan</Link></li>
              <li><Link to="/page/hubungi-kami" className="text-zinc-400 hover:text-white text-sm transition-colors">Hubungi Kami</Link></li>
            </ul>
          </div>
        </div>


        {/* Bottom bar */}
        <div className="border-t border-zinc-900 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-xs font-mono">
            © 2026 {isReseller ? storeName : theme.brand.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            <span className="font-mono text-[10px] text-zinc-400 tracking-wider uppercase">ALL SYSTEMS OPERATIONAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
